import { ActionDescriptor } from '../common/commonTypes';
import PrependAttributeForm from './PrependAttributeForm';

const prependAttribute: ActionDescriptor = {
	FormComponent: PrependAttributeForm,
	actionTitle: 'Prepend',
};

export default prependAttribute;
